import type { Location } from "@medplum/fhirtypes";
import { LOCATION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Location resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useLocationSubscription = createSubscriptionHook<Location>("Location", LOCATION_COLLECTION_NAME);
